import React, { memo } from 'react';
import ExerciseCanvas from "./exercise-canvas";

const VariationContentPreview = ({ collection = [], size = 188 }) => {
  const width = Math.round(size / 2) - 4;
  const height = Math.round(size / 2) - 4;

  return (
    <div className="exercise-collection-items" style={{ width, height }}>
      {[1, 2, 3, 4].map(position => {
        const item = collection.find(el => el?.position === position);
        return <VariationContentItem key={position} {...{ item, width, height, position }} />;
      })}
    </div>
  );
};

export const VariationContentItem = ({ item, width = 90, height = 90, position }) => {
  return (
    <div key={position} className="exercise-item-wrapper">
      {item && ( <span className="position" style={{ fontSize: Math.round(width / 2) }}>{position}</span>)}
      <ContentItem {...{ item, width, height, type: item?.exercise_collectible_type }} />
    </div>
  );
};

export const ContentItem = ({ item, type, width, height }) => {
  switch (type) {
    case "Aktion":
      return <img src={item?.content?.image || item?.image || item?.video_preview_image_app_url } alt={item.title} style={{ objectFit: 'cover', width, height }}/>
    case "Exercise":
      return <ExerciseCanvas {...{ width, height }} exercise={item.content}/>
    case "ExerciseCollection":
      return <VariationContentPreview size={height + 4} collection={item?.content?.exercise_collections_exercises_attributes || item?.exercise_collections_exercises_attributes}/>
    default:
      return <div className="content-empty" style={{width, height}}>
       <img src="/images/logo.png" alt="logo" />
      </div>
  }
}

export const PracticeTemplatePreview = ({ collection = [], size = 188 }) => {
  const width = Math.round(size / 2) - 4;
  const height = Math.round(size / 2) - 4;

  return (
    <div className="exercise-collection-items" style={{width, height}}>
      {[2, 3, 4, 5].map(position => {
        const item = collection.find(el => el?.position === position)
        return (<ContentItem key={position} {...{ item, width, height, type: item?.practicable_type }}> </ContentItem>)
      })}
    </div>
  )
}

export default memo(VariationContentPreview);

